<template>
  <aside class="nav-wrapper">
    <nav class="nav-container">
      <section class="nav-container__main-actions">
        <router-link to="/" id="nav-grid" v-if="hasAccessToBrowseIn">
          <div
            class="nav-button"
            @mouseover="$emit('showTooltip', $event, ['Grid View'])"
            @mouseleave="$emit('hideTooltip')"
          >
            <svg class="mds-icon" aria-hidden="true">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="static/mds/icons/mds.svg#list"
              ></use>
              <title>Grid View</title>
            </svg>
          </div>
        </router-link>
        <router-link to="/pending" id="nav-pending" v-if="hasAccessToBrowseIn">
          <div
            class="nav-button"
            @mouseover="$emit('showTooltip', $event, ['Pending View'])"
            @mouseleave="$emit('hideTooltip')"
          >
            <svg class="mds-icon" aria-hidden="true">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="static/mds/icons/mds.svg#clock-back"
              ></use>
              <title>Pending View</title>
            </svg>
          </div>
        </router-link>
        <router-link to="/reports" id="nav-resports" v-if="hasAccessToBrowseIn">
          <div
            class="nav-button"
            @mouseover="$emit('showTooltip', $event, ['Reports'])"
            @mouseleave="$emit('hideTooltip')"
          >
            <svg class="mds-icon" aria-hidden="true">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="static/mds/icons/mds.svg#document"
              ></use>
              <title>Reports</title>
            </svg>
          </div>
        </router-link>
      </section>
      <section class="nav-container__secondary-actions">
        <router-link to="/logout" id="nav-logout">
          <div
            class="nav-button"
            @mouseover="$emit('showTooltip', $event, ['Log Out'])"
            @mouseleave="$emit('hideTooltip')"
          >
            <svg
              class="mds-icon"
              aria-hidden="true"
              width="19px"
              height="19px"
              viewBox="0 0 19 19"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g
                  id="nav_strip"
                  transform="translate(-34.000000, -645.000000)"
                  fill="#ABABAB"
                  stroke="#979797"
                  stroke-width="0.5"
                >
                  <g id="Group-10">
                    <g id="Group-9" transform="translate(0.000000, 621.000000)">
                      <!-- eslint-disable -->
                      <g
                        id="sign_out_icon"
                        transform="translate(43.000000, 34.000000) scale(-1, 1) translate(-43.000000, -34.000000) translate(34.000000, 25.000000)"
                      >
                        <path
                          d="M10.1037375,11.8045875 L10.1037375,13.8590375 L10.1037375,16.351025 C10.1037375,16.4755373 10.0937776,16.5900875 10.0041281,16.6897075 C9.92112138,16.7826763 9.81320963,16.8142198 9.69285813,16.8142198 L9.12425063,16.8142198 L6.60081313,16.8142198 L3.45900063,16.8142198 L1.24942563,16.8142198 C1.112463,16.8142198 0.927360625,16.8391226 0.801178125,16.7810166 C0.601959375,16.6880479 0.578711875,16.4987954 0.578711875,16.3095216 L0.578711875,14.9714304 L0.578711875,12.5210929 L0.578711875,9.47894288 L0.578711875,6.29973038 L0.578711875,3.51491788 L0.578711875,1.58082788 L0.578711875,1.09773038 L0.578711875,0.999780625 C0.5803715,0.82546475 0.693262125,0.676058125 0.867584375,0.636214375 C0.99624675,0.607161375 1.14814813,0.627914125 1.27847438,0.627914125 L2.20650438,0.627914125 L5.08439188,0.627914125 L8.09997938,0.627914125 C8.63537313,0.627914125 9.17078813,0.6262545 9.70369563,0.627914125 C9.84480838,0.627914125 9.97762938,0.6793795 10.0539806,0.806380125 C10.1079365,0.89768925 10.105446,0.990658 10.105446,1.09276638 L10.105446,2.10545638 L10.105446,5.04815638 L10.105446,5.63916138 C10.105446,5.90644388 10.5204798,5.90644388 10.5204798,5.63916138 L10.5204798,3.54321013 L10.5204798,1.04888513 C10.5204798,0.841366125 10.4690144,0.652105125 10.3337114,0.488586375 C10.1801461,0.3043085 9.94772638,0.214652625 9.71280763,0.212995125 C9.53849175,0.2113355 9.36418013,0.212995125 9.19152388,0.212995125 L6.66149888,0.212995125 L3.48887388,0.212995125 L1.24104888,0.212995125 C1.03352988,0.212995125 0.823528875,0.1963925 0.628453875,0.2835515 C0.344575125,0.40806375 0.170261375,0.688619 0.163610125,0.99493775 L0.163610125,1.0779445 L0.163610125,2.3745345 L0.163610125,4.827422 L0.163610125,7.921847 L0.163610125,11.1316595 L0.163610125,13.9621595 L0.163610125,15.883797 L0.163610125,16.3502983 L0.163610125,16.4266665 C0.17025075,16.768664 0.379425125,17.0699678 0.703168875,17.186184 C0.873334625,17.2459496 1.07421513,17.2276874 1.25267263,17.2276874 L2.17573013,17.2276874 L5.10419263,17.2276874 L8.14804263,17.2276874 C8.67098388,17.2276874 9.19394638,17.2318379 9.71688763,17.2276874 C9.98665638,17.2260273 10.2298839,17.0965345 10.3826076,16.8748949 C10.4880268,16.7213296 10.5195703,16.5428636 10.5195703,16.3602411 L10.5195703,15.4015049 L10.5195703,12.4065299 L10.5195703,11.8005649 C10.5187415,11.5365974 10.1037078,11.5365974 10.1037078,11.804715 L10.1037375,11.8045875 Z"
                          id="Fill-1"
                        ></path>
                        <path
                          d="M4.44715216,9.00046159 L5.26748411,9.00046159 L7.23807999,9.00046159 L9.62116318,9.00046159 L11.6821534,9.00046159 C12.0154842,9.00046159 12.3499431,9.01790307 12.683838,9.00046159 L12.6979612,9.00046159 C12.8798779,9.00046159 12.8798779,8.51596513 12.6979612,8.51596513 L11.8776293,8.51596513 L9.90703337,8.51596513 L7.52395163,8.51596513 L5.46296143,8.51596513 C5.12963062,8.51596513 4.79517169,8.49852365 4.46127681,8.51596513 L4.44715216,8.51596513 C4.26467136,8.51596513 4.26467136,9.00046159 4.44715216,9.00046159 Z"
                          id="Fill-2"
                        ></path>
                        <g id="Group" transform="translate(13.000000, 5.000000)">
                          <path
                            d="M-2.20676491,3.47151843 C-2.24736494,3.47151864 -2.26210703,3.4705862 -2.31397367,3.46423544 C-2.36967478,3.48109231 -2.36967478,3.48109231 -2.54619574,3.20858761 C-2.36967659,2.93608671 -2.36967659,2.93608671 -2.31397597,2.9529425 C-2.26210946,2.94659123 -2.24736733,2.94565864 -2.20676734,2.94565843 L-2.19860449,2.94566067 C-2.08884387,2.94529595 -2.08884387,2.94529595 -1.97927984,2.94524352 C-1.86983118,2.94529483 -1.86983118,2.94529483 -1.76066023,2.94544953 C-1.6516505,2.94560403 -1.6516505,2.94560403 -1.54300119,2.94565504 L3.18460672,2.94563088 C3.22515739,2.94563068 3.23986692,2.94656394 3.29172937,2.95293363 C3.34756533,2.93618969 3.34756533,2.93618969 3.52376111,3.2085617 C3.34756713,3.48092992 3.34756713,3.48092992 3.29173167,3.46418706 C3.23986934,3.47055726 3.22515977,3.47149067 3.18460914,3.47149088 L3.17644724,3.47148865 C3.06668662,3.47185336 3.06668662,3.47185336 2.95712258,3.47190579 C2.84767392,3.47185449 2.84767392,3.47185449 2.73850297,3.47169978 C2.62949325,3.47154529 2.62949325,3.47154529 2.52084393,3.47149427 L-2.20676491,3.47151843 Z"
                            id="Fill-2"
                            transform="translate(0.488783, 3.208575) rotate(-271.000000) translate(-0.488783, -3.208575) "
                          ></path>
                          <path
                            d="M0.915885303,1.13865141 L1.92851998,1.94684681 C2.46668333,2.37636118 3.00317284,2.80453964 3.54217312,3.23472197 C3.66623524,3.33373738 3.79198409,3.43409899 3.915205,3.53244302 L3.915205,3.29694487 L0.915799465,5.69080498 C0.724676151,5.8433427 1.0205823,6.08017334 1.21086869,5.92630313 L4.21027423,3.53244302 C4.28990859,3.46888592 4.28990859,3.35983572 4.21027423,3.29694487 C3.87245752,3.02732946 3.53547773,2.758382 3.19763956,2.48874947 C2.6594762,2.05923509 2.1229867,1.63105664 1.58398642,1.2008743 L1.21095453,0.90315326 C1.02066814,0.750615541 0.724766281,0.986113692 0.915885303,1.13865141 Z"
                            id="Fill-3"
                          ></path>
                        </g>
                      </g>
                      <!-- eslint-enable -->
                    </g>
                  </g>
                </g>
              </g>
              <title>Log Out</title>
            </svg>
          </div>
        </router-link>
      </section>
    </nav>
  </aside>
</template>
<script>
import AccessMixin from '@/mixins/AccessMixin';

export default {
  name: 'Navigation',
  mixins: [
    AccessMixin,
  ],
  computed: {
    currentRoute() {
      return this.$route.name;
    },
  },
  methods: {
    activeRoute(route) {
      if (this.currentRoute === route) {
        return 'active';
      }
      return '';
    },
  },
};
</script>
<style lang="scss">
.nav-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__main-actions {
    -ms-flex: 1;
    flex: 1;
  }

  a {
    cursor: pointer;
    display: inline-block;
    height: 60px;
    width: 100%;

    &:nth-last-child(2) {
      flex-grow: 1;
    }
    &:nth-last-child(1) {
      margin-bottom: $mds-space-inset-2-x;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
.nav-wrapper {
  min-width: $fc-space-navigation-bar;
  max-width: $fc-space-navigation-bar;
  background-color: $fc-color-navigation-bar;

  .router-link-exact-active .nav-button {
    background-color: $fc-color-navigation-bar-nav-button;
  }
}
.nav-button {
  color: white;
  width: 100%;
  height: 60px;
  text-align: center;
  > svg {
    margin: 18px auto;
    fill: currentColor;
  }
}
</style>
